// Widget editor page, create or update widgets

import React from 'react';
import AdminAuth from '../components/admin/AdminAuth';
import WidgetEditor from '../components/admin/WidgetEditor';

const WidgetEditorPage = () => {
  return (
    <AdminAuth>
      <WidgetEditor />
    </AdminAuth>
  );
};

export default WidgetEditorPage;